var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 62,
    viewBox: "0 0 51 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3361 20.1349C41.3361 11.3895 34.2465 4.29987 25.5011 4.29987C16.7556 4.29987 9.66602 11.3895 9.66602 20.1349",
    stroke: "white",
    strokeWidth: 7.0378
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97918 20.1345C1.42443 20.1345 0.164062 21.3949 0.164062 22.9496V58.4905C0.164062 60.0453 1.42444 61.3057 2.97919 61.3057H48.0211C49.5759 61.3057 50.8362 60.0453 50.8362 58.4905V22.9496C50.8362 21.3949 49.5759 20.1345 48.0211 20.1345H2.97918ZM29.4579 35.9696C29.4579 33.7832 27.6855 32.0108 25.4991 32.0108C23.3128 32.0108 21.5404 33.7832 21.5404 35.9696V47.0541C21.5404 49.2405 23.3128 51.0129 25.4991 51.0129C27.6855 51.0129 29.4579 49.2405 29.4579 47.0541V35.9696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockLg);
export default __webpack_public_path__ + "static/media/unlock-lg.27defe31cba89efac19979254d05581e.svg";
export { ForwardRef as ReactComponent };